/**
 * The legal pages, at the addresses the old WordPress site had (so links from
 * the stores, the apps and old e-mails keep working once www.makeit.app
 * redirects here): /privacy-policy, /terms-and-conditions, /cookie-policy.
 * The texts (English, as before) are static HTML in src/legal.
 */
import { useEffect } from "react";
import privacy from "../legal/privacy.html?raw";
import terms from "../legal/terms.html?raw";
import cookies from "../legal/cookies.html?raw";
import { libraryUrl } from "../data/media";
import { IS_PLAY_SITE, MAIN_ORIGIN } from "../site";
import "./landing.css";

export type LegalDoc = "privacy" | "terms" | "cookies";

const DOCS: Record<LegalDoc, { path: string; title: string; html: string }> = {
  privacy: { path: "/privacy-policy", title: "Privacy Policy", html: privacy },
  terms: { path: "/terms-and-conditions", title: "Terms and Conditions", html: terms },
  cookies: { path: "/cookie-policy", title: "Cookie Policy", html: cookies },
};

/** The legal page at `pathname` (with or without a trailing slash), if any. */
export function legalDocFor(pathname: string): LegalDoc | null {
  const p = pathname.replace(/\/+$/, "");
  return (Object.keys(DOCS) as LegalDoc[]).find((d) => DOCS[d].path === p) ?? null;
}

export function LegalPage({ doc }: { doc: LegalDoc }) {
  const d = DOCS[doc];
  useEffect(() => {
    document.title = `${d.title} · Make It`;
  }, [d.title]);
  const home = IS_PLAY_SITE ? MAIN_ORIGIN : "/";
  return (
    <div className="lp legal" lang="en" dir="ltr">
      <header className="lp-nav">
        <div className="lp-wrap lp-nav-in">
          <a className="lp-logo" href={home} aria-label="Make It">
            <img src={libraryUrl("ui/logo.png")} alt="Make It" />
          </a>
        </div>
      </header>
      <main className="lp-wrap legal-body">
        <article dangerouslySetInnerHTML={{ __html: d.html }} />
        <nav className="legal-links" aria-label="Legal">
          {(Object.keys(DOCS) as LegalDoc[]).map((k) => (
            <a key={k} href={DOCS[k].path} aria-current={k === doc ? "page" : undefined}>
              {DOCS[k].title}
            </a>
          ))}
        </nav>
      </main>
    </div>
  );
}
